import '@babel/polyfill';
import './areas';
